import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "applicationsBadge", "leasesBadge"]

  connect() {
    this.showTab("applications")
  }

  switchTab(event) {
    event.preventDefault()
    const tabName = event.currentTarget.dataset.tab

    this.tabTargets.forEach(tab => {
      tab.classList.remove("dashboard-tabs__tab--active")
    })
    event.currentTarget.classList.add("dashboard-tabs__tab--active")

    this.showTab(tabName)
  }

  showTab(tabName) {
    const applicationsContent = document.getElementById("applications-content")
    const leasesContent = document.getElementById("leases-content")

    if (tabName === "applications") {
      applicationsContent.style.display = "flex"
      leasesContent.style.display = "none"
    } else if (tabName === "leases") {
      applicationsContent.style.display = "none"
      leasesContent.style.display = "flex"
    }
  }
}
